import React from "react";
import SettingsSection from "../SettingsSection";
import ChannelPicker from "../ChannelPicker";

export default function ChannelsSection({
  channels,
  showAiChannel = false,
  aiChannel,
  setAiChannel,
  reportLogChannel,
  setReportLogChannel,
  jailChannel,
  setJailChannel,
  suggestChannel,
  setSuggestChannel,
  botAnnouncementsChannel,
  setBotAnnouncementsChannel,
  birthdayChannel,
  setBirthdayChannel,
  countingChannel,
  setCountingChannel,
  inviteLogChannel,
  setInviteLogChannel,
  quotesChannelId,
  setQuotesChannelId,
  commandPrefix,
  setCommandPrefix,
}) {
  return (
    <SettingsSection>
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.8rem", marginBottom: "15px" }}
      >
        Configure{showAiChannel ? " AI," : ""} reports, jail, suggestions,
        quotes, counting, birthdays, invite logs, Kami announcements, and optional chat
        command prefix. Welcome, leave, and counter channels are in their own
        sections.
      </p>

      <label className="input-label">CHAT COMMAND PREFIX</label>
      <input
        className="settings-input"
        value={commandPrefix || ""}
        onChange={(e) => setCommandPrefix(e.target.value.slice(0, 5))}
        placeholder="e.g. .  or  ,  or  ?  (blank = slash only)"
        maxLength={5}
      />
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.75rem", marginTop: "-8px" }}
      >
        Optional. Lets members run the short command name with this prefix, e.g.{" "}
        <code>
          {(commandPrefix || "").trim()
            ? `${commandPrefix.trim()}ban`
            : "<prefix>ban"}
        </code>{" "}
        instead of <code>/mod ban</code>.{" "}
        {(commandPrefix || "").trim() ? (
          <>
            Usage help:{" "}
            <code>{`${commandPrefix.trim()}help hug`}</code>.
          </>
        ) : (
          <>
            Leave blank for slash only. After you set one, usage help is{" "}
            <code>{"{prefix}help hug"}</code>.
          </>
        )}{" "}
        Also editable via <code>/settings</code> → Prefix.
      </p>

      {showAiChannel && (
        <>
          <label className="input-label">AI CHAT CHANNEL</label>
          <ChannelPicker
            channels={channels}
            value={aiChannel}
            onChange={setAiChannel}
            types={[0]}
            emptyLabel="Disabled"
          />
          <p
            className="help-text"
            style={{ color: "#7b6f62", fontSize: "0.75rem", marginTop: "-8px" }}
          >
            Available only on the main Nocturne server and the bot testing
            server.
          </p>
        </>
      )}

      <label className="input-label">REPORT LOG CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={reportLogChannel}
        onChange={setReportLogChannel}
        types={[0]}
      />

      <label className="input-label">JAIL CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={jailChannel}
        onChange={setJailChannel}
        types={[0]}
      />

      <label className="input-label">SUGGESTIONS CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={suggestChannel}
        onChange={setSuggestChannel}
        types={[0]}
      />

      <label className="input-label">KAMI ANNOUNCEMENTS CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={botAnnouncementsChannel}
        onChange={setBotAnnouncementsChannel}
        types={[0]}
        emptyLabel="Disabled"
      />
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.75rem", marginTop: "-8px" }}
      >
        Opt in to receive Kami bot announcements (updates, downtime, new
        features). Leave Disabled to skip them. Also settable via{" "}
        <code>/settings</code> → Channels → More channels.
      </p>

      <label className="input-label">BIRTHDAY ANNOUNCEMENTS CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={birthdayChannel}
        onChange={setBirthdayChannel}
        types={[0]}
        emptyLabel="Disabled"
      />
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.75rem", marginTop: "-8px" }}
      >
        When a member has set their birthday with{" "}
        <code>/util tools birthday</code> or <code>.tools birthday</code>, Kami
        posts a birthday message here (once per year) with a small Essence/XP
        gift. Leave Disabled to skip announcements. Also settable via{" "}
        <code>/admin set-birthday</code>.
      </p>

      <label className="input-label">QUOTES CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={quotesChannelId}
        onChange={setQuotesChannelId}
        types={[0]}
        emptyLabel="Disabled"
      />
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.75rem", marginTop: "-8px" }}
      >
        Archive for <code>/fun quote</code> and <code>.qt</code>. Members can
        optionally post there with <code>post:true</code> on slash or{" "}
        <code>.qt post</code> with prefix.
      </p>

      <label className="input-label">COUNTING CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={countingChannel}
        onChange={setCountingChannel}
        types={[0]}
        emptyLabel="Disabled"
      />
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.75rem", marginTop: "-8px" }}
      >
        Members post the next number in order (1, 2, 3…). Extra text after the
        number is fine (e.g. <code>42 nice</code>). A wrong number or the same
        person counting twice resets the chain back to 1. Other messages are
        left alone. Also settable via <code>/settings</code> → Channels → More
        channels.
      </p>

      <label className="input-label">INVITE LOG CHANNEL</label>
      <ChannelPicker
        channels={channels}
        value={inviteLogChannel}
        onChange={setInviteLogChannel}
        types={[0]}
        emptyLabel="Disabled"
      />
      <p
        className="help-text"
        style={{ color: "#7b6f62", fontSize: "0.75rem", marginTop: "-8px" }}
      >
        When someone joins, logs which invite was used, who joined, and who
        created that invite. Requires the bot to have{" "}
        <strong>Manage Server</strong> so it can read invite uses. Also
        settable via <code>/settings</code> → Channels → More channels.
      </p>
    </SettingsSection>
  );
}
